module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av132-f0ea2813b942e2012b1d261e354d41f4.jpg";